import Image1 from '../Images/image-1.jpeg'
import Image2 from '../Images/image-2.jpeg'
import Image3  from '../Images/image-3.jpeg'


const TestimonialData = [
    {
        id: 1,
        name: 'Sarah',
        image: Image1,
        text: 'I was initially hesitant about trying Baans Cleaning, but I am so glad I did! It is completely transformed the way I clean my home. The results have been amazing, and I have already recommended it to several of my friends.'
    },
    {
        id: 2,
        name: 'Emily',
        image: Image2,
        text: 'I have been using Baans Cleaning for a few months now, and I could not be happier. It is incredibly easy to use and has helped me keep my home spotless. I highly recommend it to anyone looking for a reliable cleaning service..'
    }, {
        id: 3,
        name: 'David',
        image: Image3,
        text: 'Baans Cleaning has been a game-changer for me. I have seen a huge improvement in the cleanliness of my home since I started using it. The customer support is also excellent and always willing to help.'
    },
   
]

export default TestimonialData;
